import get from "lodash/get";
import { S3 } from "../constants";

/**
 * Gets avatar url of user.
 * @param  {Object} [user] - the user object
 * @return {String} [avatar url]
 */
function getAvatarUrl(user = {}, displayWaiting = false, theme, bgAlt) {
  return user.avatar && user.avatar.s3Path
    ? `${S3.PATH}${user.avatar.s3Path}`
    : user.athleteAvatar && user.athleteAvatar.s3Path
    ? `${S3.PATH}${user.athleteAvatar.s3Path}`
    : `/img/new-icons/user-circle-bg-${theme || "dark"}${
        theme === "light" && bgAlt ? "-white" : ""
      }.svg`;
}

export default getAvatarUrl;
